import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import {
  GetFileFromAWSS3BucketByKey,
  UpdatePolicyMapping,
  GetPolicyFileById,
} from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Divider, Stack, TextField } from "@mui/material";
import moment from "moment";
import { ToastError } from "../../../UiComponents/Toaster/Toast";
import Loader from "../../../UiComponents/Loader/Loader";
import Styles from "./MappingDone.module.scss";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { NotInterestedIcon } from "../../../Resources/Icons/icons";

const MappingDone = (props) => {
  const { setOpenMapingDonedrawer, selectedData, GetData } = props;
  const [openLoader, setOpenLoader] = useState(false);
  const navigate = useNavigate();
  const UserId = sessionStorage.getItem("UserId");
  const [remarks, setRemarks] = useState();
  const fontSize = "18px";
  console.log(selectedData?.policyTable, "SPU");
  const UpdatePolicyMappingFunction = (key) => {
    const data = {
      action: key,
      policyId: selectedData?._id,
      remark: remarks,
    };
    UpdatePolicyMapping(data).then((res) => {
      setOpenMapingDonedrawer(false);
      GetData();
    });
  };

  const OpenPolicyFile = (row) => {
    setOpenLoader(true);
    GetPolicyFileById(row._id)
      .then((res) => {
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        setOpenLoader(false);
        // Changes by Arun
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`
        );
        // const pdfWindow = window.open("", "_blank");
        // pdfWindow?.document?.write(`<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`);
      });
  };

  // Changes by Arun
  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };

  return (
    <>
      <div className={Styles.MainRenderinContainer}>
        <Stack direction={"row"} alignItems={"center"}>
          <div className="breadcrumb" style={{ marginLeft: "33px" }}>
            <a
              className="text-color"
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Home"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a
              className="text-color"
              onClick={() => {
                setOpenMapingDonedrawer(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {"Policy Mapping"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a className="text-color">{"Mapping Details"}</a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
          </div>
        </Stack>
        <div className={Styles.formContainer}>
          <Grid
            container
            className="Master_Card_Container"
            sx={{ border: "none" }}
          >
            <Grid
              container
              alignItems={"center"}
              className="Master_Card_Sub_Container"
            >
              <Grid item xs={12} sm={6}>
                <Typography className="Master_Card_Tittle">
                  Policy Mapping details
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                gap={2}
                className="d-flex justify-content-end"
              >
                <Button
                  className="Master_Card_Filter_Button w-100"
                  startIcon={
                    <NotInterestedIcon
                      sx={{
                        marginRight: "1.5px",
                      }}
                    />
                  }
                  onClick={() => UpdatePolicyMappingFunction("Mapping Done")}
                >
                  Reject
                </Button>
                <Button
                  className="Master_Card_create_Button w-100"
                  onClick={() => UpdatePolicyMappingFunction("Rejected")}
                >
                  Mapping Done
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider
                sx={{
                  backgroundColor: "#EAECF0",
                  borderWidth: 1,
                }}
              />
            </Grid>
            {/* <div className={Styles.MappingContent}> */}
            {/* <Grid item xs={12}> */}
            <Grid container gap={10} className={Styles.MappingContent}>
              <Grid item xs={12} sm={5.5} className={Styles.TableBox}>
                <Typography className={Styles.TableHead}>
                  Missing Policy
                </Typography>
                <Stack className={Styles.TableMainContainer}>
                  <Grid container mt={2} className={Styles.TableContent}>
                    <Grid item xs={12} sm={4}>
                      <Typography className={Styles.ContentTitle}>
                        Policy Details
                      </Typography>
                      <Button
                        onClick={() => OpenPolicyFile(selectedData)}
                        className={Styles.ContentButton}
                      >
                        View PDF
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid container mt={2} className={Styles.TableContent}>
                    <Grid item xs={12} sm={4}>
                      <Typography className={Styles.ContentTitle}>
                        Issue Date
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {moment(selectedData?.missingPolicy?.issueDate).format(
                          "DD-MM-YYYY"
                        )}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography className={Styles.ContentTitle}>
                        Company Name
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.missingPolicy?.company}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography className={Styles.ContentTitle}>
                        Policy Number
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.missingPolicy?.policyNumber}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container mt={2} mb={2} className={Styles.TableContent}>
                    <Grid item xs={12} sm={4}>
                      <Typography className={Styles.ContentTitle}>
                        Total Premium
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.missingPolicy?.totalPremium}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography className={Styles.ContentTitle}>
                        Payment Mode
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.missingPolicy?.paymentMode}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography className={Styles.ContentTitle}>
                        User Name
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.missingPolicy?.userName}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Grid>
              {/* <Grid item xs={12} sm={2} className={Styles.TableBox}></Grid> */}
              <Grid item xs={12} sm={5.5} className={Styles.TableBox}>
                <Typography className={Styles.TableHead}>
                  Policy Table
                </Typography>
                <Stack className={Styles.TableMainContainer}>
                  <Grid container mt={2} className={Styles.TableContent}>
                    <Grid item xs={12} sm={4}>
                      <Typography className={Styles.ContentTitle}>
                        Policy Details
                      </Typography>
                      <Button
                        onClick={() => OpenPolicyFile(selectedData)}
                        className={Styles.ContentButton}
                      >
                        View PDF
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography className={Styles.ContentTitle}>
                        Policy Status
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.policyTable?.policyStatus}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography className={Styles.ContentTitle}>
                        CC Entry Status
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.policyTable?.ccEntryStatus}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container mt={2} className={Styles.TableContent}>
                    <Grid
                      item
                      xs={12}
                      sm={4}
                      sx={{ display: "flex", flexDirection: "column" }}
                    >
                      <Typography className={Styles.ContentTitle}>
                        Issue Date
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {moment(selectedData?.policyTable?.issueDate).format(
                          "DD-MM-YYYY"
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography className={Styles.ContentTitle}>
                        Company Name
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.policyTable?.company}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography className={Styles.ContentTitle}>
                        Policy Number
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.policyTable?.policyNumber}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container mt={2} mb={2} className={Styles.TableContent}>
                    <Grid item xs={12} sm={4}>
                      <Typography className={Styles.ContentTitle}>
                        Total Premium
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.policyTable?.totalPremium}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography className={Styles.ContentTitle}>
                        Payment Mode
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.policyTable?.paymentMode}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <Typography className={Styles.ContentTitle}>
                        User Name
                      </Typography>
                      <Typography className={Styles.ContentValue}>
                        {selectedData?.policyTable?.userName}
                      </Typography>
                    </Grid>
                  </Grid>
                </Stack>
              </Grid>
            </Grid>
            {/* </Grid> */}
            {/* </div> */}
          </Grid>
        </div>
      </div>
      {/* Second */}
      <div
        className={Styles.MainRenderinContainer}
        style={{ paddingTop: "20px", paddingBottom: "20px" }}
      >
        <div className={Styles.formContainer}>
          <Grid
            container
            className="Master_Card_Container"
            sx={{ border: "none" }}
          >
            <Grid
              container
              alignItems={"center"}
              className="Master_Card_Sub_Container"
            >
              <Grid item xs={12} sm={6} mt={1}>
                <Typography className="Master_Card_Tittle">Remarks</Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                className="d-flex justify-content-end"
              ></Grid>
            </Grid>

            <div style={{ width: "100%" }}>
              <Grid
                container
                sx={{
                  display:
                    selectedData?.policyMappingStatus === "Mapping"
                      ? "block"
                      : "none",
                  padding: "20px",
                }}
              >
                <Grid item xs={12} sm={5.7}>
                  <TextField
                    className={Styles.RemarksField}
                    sx={{
                      border: "1px solid red", // Border color
                      "& .MuiInputBase-root": {
                        height: "170px", // Set height for the input (text area)
                      },
                    }}
                    multiline
                    rows={4}
                    fullWidth
                    placeholder="Write user review here..."
                    onChange={(e) => setRemarks(e.target.value)}
                  />
                </Grid>
              </Grid>
              <Loader open={openLoader} />
            </div>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default MappingDone;
